import { useState, useEffect, useRef } from "react";
import img1 from "./assets/img1.jpeg";
import img2 from "./assets/img2.jpeg";
import img3 from "./assets/img3.jpeg";
import img4 from "./assets/img4.jpeg";
import img5 from "./assets/img5.jpeg";
import img6 from "./assets/img6.jpeg";
import img7 from "./assets/img7.jpeg";
import img8 from "./assets/img8.jpeg";
import img9 from "./assets/img9.jpeg";
import img10 from "./assets/img10.jpeg";
import img11 from "./assets/img11.jpeg";
import img12 from "./assets/img12.jpeg";  

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Caveat:wght@400;600;700&family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Lora:ital@0;1&display=swap');

  * { margin: 0; padding: 0; box-sizing: border-box; }

  :root {
    --cream: #fdf6ec;
    --amber: #d4843a;
    --amber-light: #f0b76a;
    --forest: #3a5a40;
    --forest-light: #588157;
    --rose: #c9736a;
    --dark: #2c1a0e;
    --warm-gray: #8b7355;
  }

  html { scroll-behavior: smooth; }

  body {
    background: var(--cream);
    font-family: 'Lora', serif;
    color: var(--dark);
    overflow-x: hidden;
  }

  .grain-overlay {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 100;
    opacity: 0.03;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
  }

  /* NAV */
  .nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 50;
    display: flex; justify-content: center; gap: 2rem;
    padding: 1rem 2rem;
    background: rgba(253,246,236,0.85);
    backdrop-filter: blur(8px);
    border-bottom: 1px solid rgba(212,132,58,0.2);
  }
  .nav a {
    font-family: 'Caveat', cursive; font-size: 1.1rem; font-weight: 600;
    color: var(--warm-gray); text-decoration: none;
    transition: color 0.3s;
  }
  .nav a:hover { color: var(--amber); }

  /* CONFETTI */
  .confetti-piece {
    position: fixed;
    width: 10px; height: 14px;
    top: -20px;
    animation: confettiFall linear forwards;
    z-index: 200;
    pointer-events: none;
    border-radius: 2px;
  }
  @keyframes confettiFall {
    0% { transform: translateY(0) rotate(0deg); opacity: 1; }
    100% { transform: translateY(105vh) rotate(720deg); opacity: 0; }
  }

  /* HERO */
  .hero {
    min-height: 100vh;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    text-align: center; padding: 6rem 2rem 4rem;
    position: relative;
    background: radial-gradient(ellipse at 60% 40%, #f5dfc0 0%, #fdf6ec 60%);
  }
  .hero-stamp {
    font-family: 'Caveat', cursive; font-size: 1rem; font-weight: 600;
    letter-spacing: 0.3em; text-transform: uppercase;
    color: var(--forest-light); border: 2px solid var(--forest-light);
    padding: 0.3rem 1.2rem; border-radius: 2px;
    margin-bottom: 1.5rem; display: inline-block;
    transform: rotate(-2deg);
    animation: fadeSlideDown 0.8s ease both;
  }
  .hero h1 {
    font-family: 'Playfair Display', serif; font-size: clamp(2.8rem, 7vw, 5.5rem);
    font-weight: 700; line-height: 1.1;
    color: var(--dark);
    animation: fadeSlideDown 0.9s 0.2s ease both;
  }
  .hero h1 em { font-style: italic; color: var(--amber); }
  .hero-sub {
    font-family: 'Lora', serif; font-style: italic;
    font-size: clamp(1rem, 2.5vw, 1.3rem); color: var(--warm-gray);
    max-width: 500px; margin: 1.5rem auto 0;
    animation: fadeSlideDown 1s 0.4s ease both;
  }
  .hero-scroll {
    margin-top: 3rem;
    font-family: 'Caveat', cursive; font-size: 1rem; color: var(--amber);
    animation: bounce 2s infinite, fadeSlideDown 1s 0.8s ease both;
  }
  .decorative-line {
    width: 120px; height: 2px;
    background: linear-gradient(90deg, transparent, var(--amber), transparent);
    margin: 1.5rem auto;
    animation: fadeSlideDown 1s 0.3s ease both;
  }

  @keyframes fadeSlideDown {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(8px); }
  }

  /* SECTION COMMONS */
  section { padding: 5rem 2rem; }
  .section-label {
    font-family: 'Caveat', cursive; font-size: 1rem; font-weight: 600;
    letter-spacing: 0.25em; text-transform: uppercase;
    color: var(--rose); margin-bottom: 0.5rem;
  }
  .section-title {
    font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem);
    font-weight: 700; color: var(--dark);
    margin-bottom: 3rem;
  }

  /* JOURNEY TIMELINE */
  .journey { background: #faf3e8; }
  .journey-inner { max-width: 900px; margin: 0 auto; }
  .timeline {
    position: relative; padding-left: 2rem;
  }
  .timeline::before {
    content: '';
    position: absolute; left: 0; top: 0; bottom: 0;
    width: 2px;
    background: linear-gradient(to bottom, var(--amber-light), var(--forest-light));
  }
  .timeline-stop {
    position: relative; margin-bottom: 3.5rem;
    opacity: 0; transform: translateX(-30px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .timeline-stop.visible { opacity: 1; transform: translateX(0); }
  .timeline-dot {
    position: absolute; left: -2.45rem; top: 0.4rem;
    width: 18px; height: 18px; border-radius: 50%;
    background: var(--amber); border: 3px solid var(--cream);
    box-shadow: 0 0 0 2px var(--amber);
  }
  .stop-card {
    background: white; border-radius: 12px;
    padding: 1.8rem 2rem;
    box-shadow: 4px 4px 20px rgba(44,26,14,0.08);
    border-left: 4px solid var(--amber);
    display: flex; gap: 1.5rem; align-items: flex-start;
    transition: transform 0.3s, box-shadow 0.3s;
  }
  .stop-card:hover {
    transform: translateY(-4px);
    box-shadow: 6px 8px 30px rgba(44,26,14,0.13);
  }
  .stop-emoji { font-size: 2.8rem; flex-shrink: 0; }
  .stop-location {
    font-family: 'Caveat', cursive; font-size: 0.85rem; font-weight: 600;
    letter-spacing: 0.2em; text-transform: uppercase;
    color: var(--forest-light); margin-bottom: 0.3rem;
  }
  .stop-title {
    font-family: 'Playfair Display', serif; font-size: 1.4rem;
    font-weight: 700; color: var(--dark); margin-bottom: 0.5rem;
  }
  .stop-desc {
    font-family: 'Lora', serif; font-style: italic;
    color: var(--warm-gray); font-size: 0.95rem; line-height: 1.6;
  }

  /* POLAROID GALLERY */
  .gallery { background: var(--cream); }
  .gallery-inner { max-width: 1100px; margin: 0 auto; }
  .polaroid-grid {
    display: flex; flex-wrap: wrap; gap: 1.5rem;
    justify-content: center;
  }
  .polaroid {
    background: white;
    padding: 0.8rem 0.8rem 2.5rem;
    box-shadow: 3px 3px 15px rgba(44,26,14,0.15), 0 1px 3px rgba(0,0,0,0.1);
    width: 200px;
    transition: transform 0.35s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.35s;
    cursor: pointer;
    opacity: 0; 
    animation: none;
  }
  .polaroid.visible {
    animation: popIn 0.5s ease forwards;
  }
  @keyframes popIn {
    from { opacity: 0; transform: scale(0.8) rotate(var(--rot)); }
    to { opacity: 1; transform: scale(1) rotate(var(--rot)); }
  }
  .polaroid:hover {
    transform: scale(1.08) rotate(0deg) !important;
    box-shadow: 8px 12px 35px rgba(44,26,14,0.25);
    z-index: 10;
  }
  .polaroid-img {
    width: 100%; height: 160px; object-fit: cover;
    display: block; border-radius: 2px;
  }
  .polaroid-img-placeholder {
    width: 100%; height: 160px; border-radius: 2px;
    display: flex; align-items: center; justify-content: center;
    font-size: 2.5rem;
  }
  .polaroid-caption {
    font-family: 'Caveat', cursive; font-size: 1rem;
    color: var(--warm-gray); text-align: center;
    margin-top: 0.5rem; line-height: 1.3;
  }
  .polaroid-tag {
    font-size: 0.72rem; font-weight: 600;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--forest-light);
  }

  /* MEMORIES QUOTE */
  .memories {
    background: linear-gradient(135deg, #3a5a40 0%, #2c1a0e 100%);
    color: white; text-align: center;
  }
  .memories .section-label { color: var(--amber-light); }
  .memories .section-title { color: white; }
  .quote-cards { max-width: 800px; margin: 0 auto; display: flex; flex-direction: column; gap: 2rem; }
  .quote-card {
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 12px; padding: 2rem 2.5rem;
    backdrop-filter: blur(4px);
    position: relative;
    opacity: 0; transform: translateY(20px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
  .quote-card.visible { opacity: 1; transform: translateY(0); }
  .quote-mark {
    font-family: 'Playfair Display', serif; font-size: 5rem;
    color: var(--amber); line-height: 0; position: absolute;
    top: 1.5rem; left: 1.5rem; opacity: 0.4;
  }
  .quote-text {
    font-family: 'Lora', serif; font-style: italic;
    font-size: 1.1rem; color: rgba(255,255,255,0.9);
    line-height: 1.7; padding-left: 1rem;
  }
  .quote-author {
    font-family: 'Caveat', cursive; font-size: 1rem;
    color: var(--amber-light); margin-top: 0.8rem;
    text-align: right;
  }

  /* FAREWELL */
  .farewell { background: #faf3e8; text-align: center; }
  .farewell-card {
    max-width: 680px; margin: 0 auto;
    background: white; border-radius: 16px;
    padding: 3.5rem 3rem;
    box-shadow: 0 8px 40px rgba(44,26,14,0.1);
    position: relative; overflow: hidden;
  }
  .farewell-card::before {
    content: '';
    position: absolute; top: 0; left: 0; right: 0; height: 5px;
    background: linear-gradient(90deg, var(--amber), var(--rose), var(--forest-light), var(--amber));
    background-size: 200% 100%;
    animation: shimmer 3s linear infinite;
  }
  @keyframes shimmer {
    0% { background-position: 0% 0%; }
    100% { background-position: 200% 0%; }
  }
  .farewell-emoji { font-size: 4rem; margin-bottom: 1rem; }
  .farewell-name {
    font-family: 'Caveat', cursive; font-size: 2rem; font-weight: 700;
    color: var(--amber); margin-bottom: 0.5rem;
  }
  .farewell-msg {
    font-family: 'Lora', serif; font-style: italic;
    color: var(--warm-gray); font-size: 1.05rem; line-height: 1.8;
    margin: 1.5rem 0;
  }
  .signatures {
    display: flex; flex-wrap: wrap; justify-content: center; gap: 0.5rem 1.5rem;
    margin-top: 2rem; padding-top: 1.5rem;
    border-top: 1px dashed rgba(139,115,85,0.3);
  }
  .signature {
    font-family: 'Caveat', cursive; font-size: 1.1rem;
    color: var(--dark); font-weight: 600;
  }
  .heart-burst {
    font-size: 2rem; margin-top: 2rem;
    animation: heartbeat 1.5s ease-in-out infinite;
  }
  @keyframes heartbeat {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.2); }
  }

  /* FOOTER */
  .footer {
    text-align: center; padding: 2rem;
    font-family: 'Caveat', cursive; font-size: 1rem;
    color: var(--warm-gray);
    border-top: 1px solid rgba(139,115,85,0.15);
  }
`;

const PHOTOS = [
  { img: img1,  caption: "Chetpet lake vibes",       tag: "Mount road   ",  rot: -3 },
  { img: img2,  caption: "Good movies",       tag: "Marina",  rot:  2 },
  { img: img3,  caption: "Our cycle talks!",           tag: "vandaloor zoo",  rot: -1 },
  { img: img4,  caption: "Golden hour memories 🌅",   tag: "Barbeqe nation",  rot:  3 },
  { img: img5,  caption: "That moment we took images 😂",tag: "Vivira",  rot: -2 },
  { img: img6,  caption: "Bloom like us 🌺",      tag: "D Top",  rot:  1 },
  { img: img7,  caption: "King of the food! 🦁",       tag: "D Top", rot:  4 },
  { img: img8,  caption: "Bigger than us 🐘",    tag: "Excelacom", rot: -2 },
  { img: img9,  caption: "Colourful friends 🦜",      tag: "Barbeqe nation", rot:  3 },
  { img: img10, caption: "Wild hearts Thalaserry",  tag: "Thalassery", rot: -4 },
  { img: img11, caption: "Squad goals forever 🌿",    tag: "Excelacom",      rot:  2 },
  { img: img12, caption: "Till we meet again ❤️",     tag: "Excelacom",      rot: -1 },
];

// const PHOTOS = [
//   { emoji: "🌊", caption: "Chetpet lake vibes", tag: "Chetpet", bg: "linear-gradient(135deg,#a8edea,#fed6e3)", rot: -3 },
//   { emoji: "🌳", caption: "Park walks & gossip", tag: "Chetpet", bg: "linear-gradient(135deg,#d4fc79,#96e6a1)", rot: 2 },
//   { emoji: "☕", caption: "Our chai break!", tag: "Chetpet", bg: "linear-gradient(135deg,#ffecd2,#fcb69f)", rot: -1 },
//   { emoji: "🦁", caption: "King of the zoo!", tag: "Vandaloor", bg: "linear-gradient(135deg,#fbc2eb,#a6c1ee)", rot: 4 },
//   { emoji: "🐘", caption: "Bigger than us both 🐘", tag: "Vandaloor", bg: "linear-gradient(135deg,#a1c4fd,#c2e9fb)", rot: -2 },
//   { emoji: "🦜", caption: "Colourful friends", tag: "Vandaloor", bg: "linear-gradient(135deg,#fddb92,#d1fdff)", rot: 3 },
//   { emoji: "🌺", caption: "Bloom like you do", tag: "Vandaloor", bg: "linear-gradient(135deg,#ff9a9e,#fecfef)", rot: -4 },
//   { emoji: "😂", caption: "That moment we got lost", tag: "Both", bg: "linear-gradient(135deg,#f9f586,#ffeaa7)", rot: 1 },
//   { emoji: "🌅", caption: "Golden hour memories", tag: "Chetpet", bg: "linear-gradient(135deg,#f6d365,#fda085)", rot: -2 },
//    { img: img1, caption: "Chetpet lake vibes", tag: "Chetpet", rot: -3 },
// ];

const QUOTES = [
  { text: "Every office has moments that become stories. Ours became adventures — from the calm waters of Chetpet to the wild hearts of Vandaloor. Every single one of them had you in it.", author: "— Your Team 🌿" },
  { text: "You didn't just fill a seat in this office. You filled it with laughter, kindness, and the kind of energy that made Mondays worth showing up for.", author: "— The Whole Crew ❤️" },
  { text: "Wherever your next chapter takes you, know that a piece of Chetpet lake, a piece of Vandaloor, and a whole lot of us travels with you.", author: "— With Love 🌸" },
];

function useIntersection(ref, threshold = 0.15) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref, threshold]);
  return visible;
}

function Confetti({ active }) {
  const pieces = Array.from({ length: 60 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    color: ["#d4843a","#c9736a","#3a5a40","#f0b76a","#588157","#fdf6ec"][i % 6],
    duration: 2.5 + Math.random() * 2,
    delay: Math.random() * 1.5,
    size: 8 + Math.random() * 8,
  }));
  if (!active) return null;
  return (
    <>
      {pieces.map(p => (
        <div key={p.id} className="confetti-piece" style={{
          left: `${p.left}%`, background: p.color,
          width: p.size, height: p.size * 1.4,
          animationDuration: `${p.duration}s`,
          animationDelay: `${p.delay}s`,
        }} />
      ))}
    </>
  );
}

function TimelineStop({ stop, delay }) {
  const ref = useRef(null);
  const visible = useIntersection(ref);
  return (
    <div ref={ref} className={`timeline-stop${visible ? " visible" : ""}`} style={{ transitionDelay: `${delay}s` }}>
      <div className="timeline-dot" />
      <div className="stop-card">
        <div className="stop-emoji">{stop.emoji}</div>
        <div>
          <div className="stop-location">📍 {stop.location}</div>
          <div className="stop-title">{stop.title}</div>
          <div className="stop-desc">{stop.desc}</div>
        </div>
      </div>
    </div>
  );
}

function PolaroidCard({ photo, delay }) {
  const ref = useRef(null);
  const visible = useIntersection(ref);
  return (
    <div ref={ref} className={`polaroid${visible ? " visible" : ""}`}
      style={{ "--rot": `${photo.rot}deg`, animationDelay: `${delay}s` }}>

      {photo.img ? (
        <img src={photo.img} className="polaroid-img" alt={photo.caption} />
      ) : (
        <div className="polaroid-img-placeholder" style={{ background: photo.bg }}>
          {photo.emoji}
        </div>
      )}

      <div className="polaroid-caption">
        <div className="polaroid-tag">{photo.tag}</div>
        {photo.caption}
      </div>
    </div>
  );
}

// function PolaroidCard({ photo, delay }) {
//   const ref = useRef(null);
//   const visible = useIntersection(ref);
//   return (
//     <div ref={ref} className={`polaroid${visible ? " visible" : ""}`}
//       style={{ "--rot": `${photo.rot}deg`, animationDelay: `${delay}s` }}>
//       <div className="polaroid-img-placeholder" style={{ background: photo.bg }}>
//         {photo.emoji}
//       </div>
//       <div className="polaroid-caption">
//         <div className="polaroid-tag">{photo.tag}</div>
//         {photo.caption}
//       </div>
//     </div>
//   );
// }

function QuoteCard({ quote, delay }) {
  const ref = useRef(null);
  const visible = useIntersection(ref);
  return (
    <div ref={ref} className={`quote-card${visible ? " visible" : ""}`} style={{ transitionDelay: `${delay}s` }}>
      <div className="quote-mark">"</div>
      <div className="quote-text">{quote.text}</div>
      <div className="quote-author">{quote.author}</div>
    </div>
  );
}

const STOPS = [
  { emoji: "🌊", location: "Chetpet, Chennai", title: "The Lake That Listened", desc: "We walked by the eco-park, laughed too loud, took pictures from every angle. Chetpet had never seen such enthusiastic visitors." },
  { emoji: "🦁", location: "Vandaloor Zoo, Chennai", title: "Wild Hearts at Vandaloor", desc: "Lions, elephants, colourful birds — and us, acting like we had never seen animals before. The best field trip this office ever took." },
  //  { emoji: "☕", location: "Every chai stall in between", title: "The Pit Stops That Made It", desc: "No adventure is complete without the unplanned chai breaks, the wrong turns, and the detours that ended up being the best parts." },
];

export default function App() {
  const [confetti, setConfetti] = useState(false);

  useEffect(() => {
    setTimeout(() => setConfetti(true), 600);
    setTimeout(() => setConfetti(false), 4500);
  }, []);

  return (
    <>
      <style>{style}</style>
      <div className="grain-overlay" />
      <Confetti active={confetti} />

      {/* NAV */}
      <nav className="nav">
        <a href="#journey">Journey</a>
        <a href="#gallery">Gallery</a>
        <a href="#memories">Memories</a>
        <a href="#farewell">Farewell</a>
      </nav>

      {/* HERO */}
      <section className="hero" id="home">
        <div className="hero-stamp">✦ A Farewell Story ✦</div>
        <h1>A Journey <em>To Remember</em></h1>
        <div className="decorative-line" />
        <p className="hero-sub">
          Before you walk out that door — let's flip through the pages of our little adventure together.
        </p>
        <div className="hero-scroll">↓ scroll down ↓</div>
      </section>

      {/* JOURNEY */}
      <section className="journey" id="journey">
        <div className="journey-inner">
          <div className="section-label">✦ Our Adventures</div>
          <div className="section-title">The Places We Roamed</div>
          <div className="timeline">
            {STOPS.map((stop, i) => <TimelineStop key={i} stop={stop} delay={i * 0.15} />)}
          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section className="gallery" id="gallery">
        <div className="gallery-inner">
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <div className="section-label">✦ Our Polaroids</div>
            <div className="section-title">Moments We Captured</div>
          </div>
          <div className="polaroid-grid">
            {PHOTOS.map((photo, i) => <PolaroidCard key={i} photo={photo} delay={i * 0.08} />)}
          </div>
        </div>
      </section>

      {/* MEMORIES */}
      {/* <section className="memories" id="memories">
        <div style={{ marginBottom: "3rem" }}>
          <div className="section-label">✦ From The Heart</div>
          <div className="section-title">Things We Never Said Enough</div>
        </div>
        <div className="quote-cards">
          {QUOTES.map((q, i) => <QuoteCard key={i} quote={q} delay={i * 0.2} />)}
        </div>
      </section> */}

      {/* FAREWELL */}
      <section className="farewell" id="farewell">
        <div className="section-label" style={{ textAlign: "center" }}>✦ Until We Meet Again</div>
        <div className="section-title" style={{ textAlign: "center" }}>Goodbye,</div>
        <div className="farewell-card">
          <div className="farewell-emoji">🌿</div>
          <div className="farewell-name">You'll Be Missed</div>
          {/* <p className="farewell-msg">
            This office will feel a little quieter, our lunch breaks a little less fun, and our chai a little less sweet.
            But knowing you're out there doing incredible things? That makes it all worth it.
            <br /><br />
            From Chetpet to Vandaloor and every ordinary Tuesday in between — thank you for making it all extraordinary.
          </p> */}
          <div className="signatures">
            {["Sabari 🌿"].map((s, i) => (
              <span key={i} className="signature">{s}</span>
            ))}
          </div>
          {/* <div className="heart-burst">❤️</div> */}
        </div>
      </section>

      <footer className="footer">
        Made with love for someone who made every day better ✦
      </footer>
    </>
  );
}
